/* eslint-disable */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-this-alias */
/* global $, isPool */
import * as d3 from 'd3'

import template from 'lodash/template'
import _filter from 'lodash/filter'
import _reduce from 'lodash/reduce'
import _groupBy from 'lodash/groupBy'

import Table from 'bam-node-savant-table'
import 'bam-node-savant-table/styles/table.less'

import { displayFn } from 'bam-node-baseball-savant/utils/guff'
import HitPainter from './hit-spread/hit_painter'

import modelUtil from './util/model_util'
import HitsView from './hits_view'
import HitSequence from './hit-spread/hit_sequence'

import Picker from './util/picker'

const hitPainter = new HitPainter()

const detailsTemplateStr =
    '<span class="details-template"><strong><%= playerName %></strong><br/>Launch Speed: <%= speed %> MPH<br/>Launch Angle: <%= angle %>°<br/' +
    '>Height: <%= maxHeight %>ft.<br/>Distance: <%= distance %>ft.</span>'
const detailsTemplate = template(detailsTemplateStr)
const SPIN_TXT = 'Spin Field'
const NO_SPIN_TXT = 'No Spin'

function reset(that) {
    that.cancelCurrentSequence()
    that.picker.enabled(false)
}

function hideMessage() {
    d3.select('#message')
        .transition()
        // .duration(1000)
        .style('opacity', 0)
        .on('end', function () {
            d3.select(this).style('display', 'none').style('opacity', 1)
        })
}

function UI(canvasEl, gl, loop, controls) {
    const that = this
    const pickerDebounceInterva = 400
    let pickerTimeoutId

    this.state = {
        autoRotate: false,
        model: null,
        displayedPlayerRound: modelUtil.createPlayerRound(),
        livePlayerRound: modelUtil.createPlayerRound(),
    }

    this.gl = gl
    this.loop = loop
    this.controls = controls
    this.hitsView = new HitsView(gl, loop)
    this.currentSequence = null
    this.picker = new Picker(canvasEl, gl, onMouseOverHit)

    hitPainter.highlightRangeHandler(this.highlightRange.bind(this))

    d3.select('#btnClear').on('click', () => {
        that.cancelCurrentSequence()
        // that.loop.stop();
        that.hitsView.clear()
    })

    d3.select(canvasEl).on('click', () => {
        that.hitsView.highlightHits()
    })

    d3.select('#btnSpin').on('click', function () {
        const btn = d3.select(this)

        if (that.state.autoRotate) {
            btn.text(SPIN_TXT)
            that.autoRotate(false)
        } else {
            btn.text(NO_SPIN_TXT)
            that.autoRotate(true)
        }
    })

    // TODO: This isn't working, do we want it?
    // automatically spin on startup
    // this.autoRotate(true)
    // d3.select('#btnSpin').text(NO_SPIN_TXT)

    function handlePointerBegin() {
        that.autoRotate(false)
        // turning off autoRotate normally re0enables picker, so disable here after turning off rotation
        that.picker.enabled(false)
        d3.select('#btnSpin').text(SPIN_TXT)
    }

    function handlePointerEnd() {
        that.picker.enabled(true)
    }

    canvasEl.addEventListener('mousedown', () => {
        handlePointerBegin()
    })

    canvasEl.addEventListener('mouseup', () => {
        handlePointerEnd()
    })

    canvasEl.addEventListener(
        'touchstart',
        () => {
            handlePointerBegin()
        },
        true
    )

    canvasEl.addEventListener(
        'touchend',
        () => {
            handlePointerEnd()
        },
        true
    )

    d3.selectAll('.color_option')
        .on('click', colorSelClick)
        .on('mouseover', colorSelOver)
        .on('mouseout', colorSelOut)

    function colorSelClick() {
        d3.selectAll('.color_option').classed('selected', false)
        d3.select(this).classed('selected', true)
    }

    function colorSelOver() {
        const value = d3.select(this).attr('data-value')
        const isDisabled = d3.select(this).classed('disabled')

        if (isDisabled) {
            return
        }

        d3.selectAll('.color_option').classed('active', false)
        d3.select(this).classed('active', true)

        hitPainter.paint(that.hitObjects, value)
        // hitPainter.renderLegend(legendSel, value);
        that.gl.tick()
    }

    function colorSelOut() {
        const selected = d3.select('.color_option.selected')
        const value = selected.attr('data-value')

        hitPainter.paint(that.hitObjects, value)
        //            hitPainter.renderLegend(legendSel, value);
        that.gl.tick()
        d3.selectAll('.color_option').classed('active', false)
        selected.classed('active', true)
    }

    function onMouseOverHit(data, hitObject) {
        const details = d3.select('.overlay.details')
        details.node().classList.remove('hide')
        const hits = that.hitObjects

        if (pickerTimeoutId) {
            clearTimeout(pickerTimeoutId)
            pickerTimeoutId = null
        }

        if (data) {
            that.hitsView.highlightHits([data.playId])
            displayDetails(data)
        } else {
            pickerTimeoutId = setTimeout(() => {
                pickerTimeoutId = null
                restore()
            }, pickerDebounceInterva)
        }

        function restore() {
            that.hitsView.highlightHits()
            details.html('').node().classList.add('hide')
        }

        function displayDetails(dataDetail) {
            const { playerName } = dataDetail
            const metrics = dataDetail.result.computedMetrics
            const speed = metrics.exitVelocity
            const speedStr = speed.value.toFixed(1)
            const // + ' ' + speed.unit,
                distance = metrics.projectedDistance
            const distanceStr = Math.round(distance.value)
            const // + ' ' + distance.unit,
                maxHeight = metrics.maxHeight.value.toFixed(0)
            const angle = metrics.launchAngle.value.toFixed(0)
            const html = detailsTemplate({
                playerName,
                angle,
                speed: speedStr,
                distance: distanceStr,
                maxHeight,
            })

            details.html(html)
        }
    }

    d3.select('#btnFireSeries').on('click', () => {
        // that.cancelCurrentSequence();
        reset(that)
        that.currentSequence = that.sequenceSeries.start()
    })

    d3.select('#btnFireAll').on('click', () => {
        reset(that)
        that.currentSequence = that.sequenceAll.start()
    })

    d3.select('#btnFireStaggered').on('click', () => {
        reset(that)
        that.currentSequence = that.sequenceStaggered.start()
    })

    d3.select('#btnFireStaggered2').on('click', () => {
        reset(that)
        that.currentSequence = that.sequenceStaggered2.start()
    })

    d3.select('#btnFireStaggered2b').on('click', () => {
        reset(that)
        that.currentSequence = that.sequenceStaggered2b.start()
    })

    d3.select('#hit_color_sel').on('change', this.paintHits.bind(this))

    this.syncToState()
}

function toDistance(hitObject) {
    return hitObject.userData.result.computedMetrics.projectedDistance.value
}

function toSpeed(filter) {
    return hitObject.userData.result.computedMetrics.exitVelocity.value
}

function toAngle(hitObject) {
    return hitObject.userData.result.computedMetrics.launchAngle.value
}

function toHeight(hitObject) {
    return hitObject.userData.result.computedMetrics.maxHeight.value
}

function filter(hitObjects, toValue, min, max) {
    return _filter(hitObjects, (hitObject) => {
        const value = toValue(hitObject)

        return min <= value && value < max
    })
}

const tyoeFilterMap = {
    distance: toDistance,
    exit_speed: toSpeed,
    launch_angle: toAngle,
    height: toHeight,
}

UI.prototype.highlightRange = function highlightRange(type, dMin, dMax) {
    if (type === undefined || type === null) {
        // TODOHI  restore
    } else {
        // TODOHI  map to filter, then find and highlight hitObjects
        const highlightedHitObjects = filter(
            this.hitObjects,
            tyoeFilterMap[type],
            dMin,
            dMax
        )
        const playIds = highlightedHitObjects.map(
            (hitObject) => hitObject.userData.playId
        )

        this.hitsView.highlightHits(playIds)
    }
}

UI.prototype.syncToState = function syncToState() {
    // Not sure why things were disabled, so noop-ing it for now.
    //
    // const isSomePrDisplayed = !this.state.displayedPlayerRound.isNull()
    // const isNonLprDisplayed =
    //     isSomePrDisplayed && !isLivePlayerRoundDisplayed(this.state)
    // const hasHits = this.state.model && this.state.model.rounds.length > 0
    // d3.selectAll('button.fire').attr(
    //     'disabled',
    //     isNonLprDisplayed ? null : 'true'
    // )
    // d3.selectAll('.color_option').attr('disabled', !hasHits ? 'true' : null)
}

function hitColorSelection() {
    // return d3.select('#hit_color_sel').node().value;
    return d3.select('.color_option.selected').attr('data-value')
}

UI.prototype.paintHits = function paintHits() {
    // var value = d3.select('#hit_color_sel').node().value;
    const value = hitColorSelection()

    // console.log('change - value: ' + value);
    // console.dir(that.hitObjects);
    hitPainter.paint(this.hitObjects, value)
    //        hitPainter.renderLegend(legendSel, value);
    this.gl.tick()
}

UI.prototype.autoRotate = function autoRotate(doRotate) {
    const changeState = doRotate !== this.state.autoRotate

    if (!changeState) {
        return
    }

    this.state.autoRotate = doRotate
    this.controls.autoRotate = doRotate

    // TODOHI  coordinate with sequence playback state - done?
    if (doRotate) {
        this.loop.start()
    } else {
        this.loop.stop()
    }

    this.picker.enabled(!doRotate)
}

UI.prototype.cancelCurrentSequence = function cancelCurrentSequence() {
    if (this.currentSequence) {
        this.currentSequence.pause()
    }
}

function placeholder(prop, suffix = '', round = 0) {
    if (prop.value) {
        return prop.value.toFixed(round) + suffix
    }
    return `<span class="hide">0</span> --`
}

function getRoundLabel(round, meta) {
    let roundName = ''
    let roundSuffix = ''
    switch (meta.summary.order) {
        case 1:
        case 2:
            roundSuffix = 'A'
            break
        case 3:
        case 4:
            roundSuffix = 'B'
            break
        case 5:
        case 6:
            roundSuffix = 'C'
            break
        case 7:
        case 8:
            roundSuffix = 'D'
            break
        default:
            roundSuffix = ''
    }
    switch (round) {
        case 1:
            roundName = isPool ? 'Pool' : `Quarter ${roundSuffix}`
            break
        case 2:
            roundName = `Semi ${roundSuffix}`
            break
        case 3:
            roundName = 'Finals'
            break
        default:
            roundName = '--'
            break
    }

    return roundName
}

/**
 * Initializes play sequences and paints hits with current coloring selection
 * @param hitObjects array of threejs Object3D
 * @returns {UI}
 */
UI.prototype.setHitObjects = function setHitObjects(hitObjects) {
    const that = this

    /* console.log("HERE");
         console.log(hitObjects); */

    this.hitObjects = hitObjects || []

    function sequenceEnded() {
        console.log('sequenceEnded - loop count:', that.loop.state.activeCount)
        that.setTable()
    }

    this.sequenceSeries = HitSequence.sequential(
        this.hitObjects,
        this.loop,
        500
    )
        // .onHitEnter(displayHit)
        .onSequenceEnd(sequenceEnded)
    this.sequenceAll = HitSequence.simultaneous(
        this.hitObjects,
        this.loop,
        3000
    ).onSequenceEnd(sequenceEnded)
    // .onHitEnter(displayHit)
    this.sequenceStaggered = HitSequence.staggered(
        this.hitObjects,
        this.loop,
        500
    )
        // .onHitEnter(displayHit)
        .onSequenceEnd(sequenceEnded)
    this.sequenceStaggered2 = HitSequence.staggered2(
        this.hitObjects,
        this.loop,
        500
    )
        // .onHitEnter(displayHit)
        .onSequenceEnd(sequenceEnded)
    this.sequenceStaggered2b = HitSequence.staggered2(
        this.hitObjects,
        this.loop,
        2000
    )
        // .onHitEnter(displayHit)
        .onSequenceEnd(sequenceEnded)

    return this
}

UI.prototype.updateDisplayRound = function updateDisplayRound(
    playerId,
    roundTypeChar
) {
    const round = this.players
        .find((d) => d[0].playerId === Number(playerId))
        .find((d) => d.roundType.slice(0, 1) === roundTypeChar)

    this.state.displayedPlayerRound = modelUtil.createPlayerRound(round)
}

function fillPlayerRoundsSelect(ui, playerRounds) {
    for (let x = 0; x < playerRounds.length; x++) {
        const spanId = `fire_${playerRounds[x].playerId}_${playerRounds[
            x
        ].roundType.substring(0, 1)}`
        const sel = `#playerMugshots #${spanId}`

        $(`#p_${playerRounds[x].playerId}_selector`).append(
            `<span class="round" id="${spanId}">${playerRounds[
                x
            ].roundType.substring(0, 1)}</span> `
        )

        // player-round click handlers
        $(sel)
            .unbind('click')
            .on('click', function handleClick() {
                /// Parse out ids stored in span id
                const [, playerId, roundType] = this.id.split('_')

                $('.round').css('color', '#399098')
                $(this).css('color', '#AEDAD6')

                ui.updateDisplayRound(playerId, roundType)
                const playerRound = ui.state.displayedPlayerRound

                if (!playerRound) {
                    return
                }

                $(`#p_${playerId}_tip`).html(playerRound.roundType)

                // Find Hits Max EV & Distance
                let { hits } = playerRound

                hits = hits.filter((d) => {
                    const [x1, y, z] = d.result.hit.path.slice(-3)
                    const dist = Math.sqrt(x1 ** 2 + y ** 2 + z ** 2)
                    const distDiff = Math.abs(
                        d.result.computedMetrics.projectedDistance.value - dist
                    )
                    return (
                        d?.result?.computedMetrics?.launchAngle?.value > 12 &&
                        distDiff < 50
                    )
                })

                ui.AddMetaHtml(playerRound)

                // Fire HRs from that round
                ui.hitsView.loadHits(hits)

                hideMessage()

                ui.setHitObjects(ui.hitsView.getHitSpread().getHitObjects())

                ui.paintHits()

                // automatically present hits
                ui.cancelCurrentSequence()
                ui.currentSequence = ui.sequenceAll.start()

                // TODO    possible to consolidate any of above in displayPlayerRound?
                ui.displayPlayerRound(playerRound)

                ui.setTable()
            })

        $('#playerMugshots').on(
            'mouseover',
            `#${spanId}`,
            function handleMouseover() {
                $('.tip').html('')
                const ids = this.id.split('_')
                const playerId = ids[1]
                const roundType = ids[2]

                const playerHRs = ui.players
                    .find((playerData) => {
                        const round = playerData[0]
                        return Number(round.playerId) === Number(playerId)
                    })
                    .filter(
                        (roundData) =>
                            roundData.roundType.substring(0, 1) === roundType
                    )

                $(`#p_${playerId}_tip`).html(playerHRs[0].roundType)
            }
        )

        $('#playerMugshots').on('mouseout', `#${spanId}`, () => {
            $('.tip').html('')
        })
    }
}

function fillPlayerSelect(ui, players) {
    const firstRounds = players.map((rounds) => rounds[0])

    const sel = d3.select('#player_sel')

    sel.selectAll('*').remove()

    // headshot click handlers
    d3.selectAll('.mugshot')
        .on('click', function handleClick() {
            const id = +d3.select(this).property('id')
            // PARSE OUT PLAYER & GROUP BY ALL HIS ROUNDS
            let player = _groupBy(
                players.find((rounds) => {
                    const round = rounds[0]

                    return round.playerId === id
                }),
                (d) => d.roundType
            )

            // FIND PLAYERS LAST ROUND, EXCLUDE ALL
            let count = -1
            const playerRound = []
            // eslint-disable-next-line no-restricted-syntax, guard-for-in
            for (const round in player) {
                count += 1
                playerRound.push(player[round][0])
            }

            if (count > 1) {
                player = playerRound[count - 1]
            } else {
                player = playerRound[count]
            }

            // Only show player data if they've started the derby
            if (player) {
                ui.AddMetaHtml(player)

                ui.hitsView.loadHits(player.hits)

                hideMessage()

                ui.setTable()

                ui.setHitObjects(ui.hitsView.getHitSpread().getHitObjects())

                ui.paintHits()

                // automatically present hits
                ui.cancelCurrentSequence()
                ui.currentSequence = ui.sequenceAll.start()

                // TODO    possible to consolidate any of above in displayPlayerRound?
                ui.displayPlayerRound(player)
            }
        })
        .selectAll('option')
        .data(firstRounds)
        .enter()
        .append('option')
        .attr('value', (d) => d.playerId)
        .text((d) => d.playerName)

    $('.rounds').html('')
    players.forEach((playerRounds) => {
        fillPlayerRoundsSelect(ui, playerRounds)
    })

    // fillPlayerRoundsSelect(ui, players[0]);
}

UI.prototype.AddMetaHtml = function AddMetaHtml(pHR) {
    const that = this

    if (pHR) {
        $('.tip').html('')
        $(`#p_${pHR.playerId}_tip`).html(pHR.roundType)
        $('.round').css('color', '#399098')
        $(`#fire_${pHR.playerId}_${pHR.roundType.substring(0, 1)}`).css(
            'color',
            '#AEDAD6'
        )

        $('.mugshot').removeClass('mugshot-selected')
        $(`#${pHR.playerId}`).addClass('mugshot-selected')

        // Find Hits Max EV & Distance
        const { hits } = pHR

        const evMax = d3.max(
            hits,
            (d) => d.result.computedMetrics.exitVelocity.value
        )
        const evMean = d3.mean(
            hits,
            (d) => d.result.computedMetrics.exitVelocity.value
        )

        const evObj =
            hits.find(
                (d) => d.result.computedMetrics.exitVelocity.value === evMax
            ) || {}

        const distMax = d3.max(
            hits,
            (d) => d.result.computedMetrics.projectedDistance.value
        )

        const distMean = d3.mean(
            hits,
            (d) => d.result.computedMetrics.projectedDistance.value
        )

        const distObj =
            hits.find(
                (d) =>
                    d.result.computedMetrics.projectedDistance.value === distMax
            ) || {}

        const totalDist = _reduce(
            hits,
            (s, f) => f.result.computedMetrics.projectedDistance.value + s, // return the sum of the accumulator and the current time. (as the the new accumulator)
            0
        )

        let distance = ''
        if (totalDist <= 4000) {
            distance = `${totalDist?.toLocaleString()}&nbsp;ft.`
        } else {
            distance = `${(totalDist / 5280).toFixed(1)}&nbsp;miles`
        }

        const totalHRs = hits.length

        $('#playerSelected').html(
            `${pHR.playerName} - ${pHR.roundType}<br/>` +
                `<span class="metric">${totalHRs}&nbsp;HRs</span> ` +
                `<span class="metric highlightable hardest" data-playId="${
                    evObj.playId
                }">Hardest:&nbsp;${
                    evMax?.toFixed(0) || '--'
                }&nbsp;MPH</span> ` +
                `<span class="metric highlightable longest" data-playId="${
                    distObj.playId
                }">Longest:&nbsp;${
                    distMax?.toFixed(0) || '--'
                }&nbsp;ft.</span> ` +
                `<span class="metric">Avg.&nbsp;EV:&nbsp;${
                    evMean?.toFixed(1) || '--'
                }&nbsp;MPH</span> ` +
                `<span class="metric">Avg.&nbsp;Distance:&nbsp;${
                    distMean?.toFixed(0) || '--'
                }&nbsp;ft.</span> ` +
                `<span class="metric total-distance">Total&nbsp;Distance:&nbsp;${distance}</span>`
        )

        d3.selectAll('.metric.highlightable')
            .on('mouseover', function handleMouseover() {
                const playId = d3.select(this).attr('data-playId')

                that.hitsView.highlightHits([playId])
            })
            .on('mouseout', () => {
                that.hitsView.highlightHits()
            })
            .on('click', function handleClick() {
                const playId = d3.select(this).attr('data-playId')

                that.hitsView.highlightHits([playId])
            })
    }
}

function isLivePlayerRoundDisplayed(state) {
    return (
        !state.displayedPlayerRound.isNull() &&
        state.displayedPlayerRound.isLiveish(state.livePlayerRound)
    )
}

/**
 * Hides all badge divs, then displays the badge for the given id. If no id, just hides all.
 * @param id
 */
function setLiveBadge(id) {
    d3.selectAll('.live_badge').style('display', 'none')
    if (id !== null && id !== undefined) {
        d3.select(`.player[data-id="${id}"] .live_badge`).style(
            'display',
            'inherit'
        )
    }
}

function autoSelectPostDerbyDefault() {
    // trigger All-All click
    $('#fire_-1_A').click()
}

const roundTypeMap = {
    Quarterfinals: 'Q',
    Semifinals: 'S',
    Finals: 'F',
    Pool: 'P',
}

UI.prototype.displayPlayerRound = function displayPlayerRound(playerRound) {
    this.state.displayedPlayerRound = modelUtil.createPlayerRound(playerRound)

    // TODOHI  trigger here?
    // this.hitsView.loadHits(playerHRs[0].hits);

    this.syncToState()
}

UI.prototype.selectLivePlayerRound = function selectLivePlayerRound(
    playerRound
) {
    const round = roundTypeMap[playerRound.roundType]
    const sel = `#fire_${playerRound.playerId}_${round}`

    this.state.livePlayerRound = playerRound
    this.state.displayedPlayerRound = playerRound

    // TODOHI  can we replace with calls to addMetaHtml, and displayPlayerRound?
    // TODO    refactor click handler in fillPlayerRoundsSelect to be callable here
    // TODO    then could update state there
    // implicitly triggers displayPlayerRound…
    $(sel).click()

    // this.addPlayerRoundHits(playerRound);
}

/**
 * Updates the hit objects in hitView's hitSpread and syncs hitSequences to match
 * @param playerRound
 */
UI.prototype.addPlayerRoundHits = function addPlayerRoundHits(playerRound) {
    // TODO    ready to drop this assertion?
    console.assert(
        playerRound !== null,
        'addPlayerRoundHits called with null playerRound'
    )

    this.hitsView.addHits(playerRound.hits)

    // note: until we can append new hits to sequences (and properly set their offset timing),
    // simply re-initializing sequences here

    const hits = this.hitsView.getHitSpread().getHitObjects()

    this.setHitObjects(this.hitsView.getHitSpread().getHitObjects())

    // TODOHI  need to restrict hit painting while highlighting MRH?
    this.paintHits()
}

/**
 * Returns true if value is neither null nor undefined
 * @param x
 * @returns {boolean}
 */
function isSet(x) {
    return x !== null && x !== undefined
}

const trace = false
function debug(...args) {
    if (trace) {
        console.log(...args)
    }
}

function toPrString(pr) {
    const prPlayerName = pr && pr.playerName ? pr.playerName : ''
    const prRound = pr && pr.roundType ? pr.roundType : ''

    if (prPlayerName === '' && prRound === '') {
        return '---'
    }

    return [prPlayerName, prRound].join(', ')
}

UI.prototype.update = function (model, isFinal) {
    const isDeltaEmpty = model.delta.length === 0
    const isFirstData = !isSet(this.state.model) && !isDeltaEmpty
    const isLprDisplayed = isLivePlayerRoundDisplayed(this.state)
    const lprChanged =
        isSet(model.livePlayerRound) &&
        !model.livePlayerRound.equals(this.state.livePlayerRound)
    const dprStr = toPrString(this.state.displayedPlayerRound)
    const lprStr = toPrString(this.state.livePlayerRound)
    const newLprStr = toPrString(model.livePlayerRound)
    const hitCountOnEntry = this.hitsView.hitSpread.getHitObjects().length
    let hitCountOnExit

    // If is liveish, find correct liveish model
    let initialRound = model.players
        .find((d) => d[0].playerId === model.activePlayer)
        .find((d) => d.roundType === model.activeRoundType)

    if (initialRound) {
        initialRound = modelUtil.createPlayerRound(initialRound)
    }

    if (isLprDisplayed) {
        const { playerId, roundType } = this.state.displayedPlayerRound
        initialRound = model.players
            .find(([d]) => d.playerId === playerId)
            .find((d) => d.roundType === roundType)
    }

    debug('enter ---------------------------------------------------')
    debug(`             DPR: ${dprStr}`)
    debug(`             LPR: ${lprStr}`)
    debug(`         new LPR: ${newLprStr}`)
    debug(`         isFinal: ${isFinal}`)
    debug(
        `    isDeltaEmpty: ${isDeltaEmpty}${
            !isDeltaEmpty ? ` (${model.delta.length})` : ''
        }`
    )
    debug(`     isFirstData: ${isFirstData}`)
    debug(`  isLprDisplayed: ${isLprDisplayed}`)
    debug(`      lprChanged: ${lprChanged}`)

    if (isFinal) {
        debug('is FINAL: hide "Live" badge')
        setLiveBadge()
    }

    this.rounds = model.rounds

    debug('1 - is delta empty?')
    if (isDeltaEmpty) {
        debug('  1Y - delta empty: is final?')

        hitCountOnExit = this.hitsView.hitSpread.getHitObjects().length
        debug(
            `hit objects - entry: ${hitCountOnEntry}, exit: ${hitCountOnExit}`
        )

        debug('exit ====================================================')
        return this
    }
    debug('  1N - delta not empty: update PR selectors')

    isSet(model.livePlayerRound) &&
        !isFinal &&
        setLiveBadge(model.livePlayerRound.playerId)

    this.state.model = model

    this.players = model.players

    fillPlayerSelect(this, model.players)

    debug('2 - state=final?')
    if (isFinal) {
        debug('2Y..6 - first data?')
        if (isFirstData) {
            // first and only data
            // 6Y - auto-select post-derby default DPR
            this.displayPlayerRound(initialRound)
            debug('  6Y - auto-select post-derby default DPR')
            autoSelectPostDerbyDefault()
        } else {
            debug('6N..7 - LPR displayed?')
            // TODOHI  need to check here if LPR changed (similar to 5 below)? rare on change to final
            if (isLprDisplayed) {
                // add hits to LPR/DPR, highlight MRH

                debug('  7Y - add hits to LPR/DPR, highlight MRH')

                // TODO    ready to drop this assertion?
                // TODOHI  why null if delta !empty?
                console.assert(
                    model.livePlayerRound !== null,
                    'model.LPR null on final data with LPR displayed'
                )

                this.displayPlayerRound(initialRound)
                this.addPlayerRoundHits(initialRound)
                this.AddMetaHtml(initialRound)
            }
            // setLiveBadge();
        }

        // derby over, no LPR
        this.state.livePlayerRound = modelUtil.createPlayerRound()
        this.syncToState()
    } else {
        debug('3 - first data?')
        if (isFirstData) {
            // auto-select new LPR, highlight MRH
            debug('  3Y - auto-select new LPR, highlight MRH')
            this.displayPlayerRound(initialRound)
            this.selectLivePlayerRound(initialRound)
        } else {
            debug('  3N..4 - LPR displayed?')
            if (isLprDisplayed) {
                debug('  4Y..5 - LPR changed?')
                if (lprChanged) {
                    // auto-select new LPR, highlight MRH

                    debug('  5N - auto-select new LPR, highlight MRH')

                    // TODO    pass delta for hits instead?
                    this.selectLivePlayerRound(model.livePlayerRound)
                } else {
                    // update LPR/DPR hit-spread, highlight MRH

                    debug('  5Y - update LPR/DPR hit-spread, highlight MRH')

                    // update player-round stats display
                    this.AddMetaHtml(initialRound)

                    this.addPlayerRoundHits(initialRound)

                    this.displayPlayerRound(initialRound)
                    // this.setTable()

                    // TODOHI  pass model.livePlayerRound.hits?
                    // this.addPlayerRoundHits(model.livePlayerRound.hits);
                }
            }
        }
    }

    this.setTable()

    hitCountOnExit = this.hitsView.hitSpread.getHitObjects().length

    debug(`hit objects - entry: ${hitCountOnEntry}, exit: ${hitCountOnExit}`)

    debug('exit ====================================================')

    return this
}

UI.prototype.setTable = function setTable() {
    const hits = this.state?.displayedPlayerRound?.hits
    const headers = [
        {
            name: 'Player',
            field: 'playerName',
            headerClass: 'th-component-header align-left',
            fieldClass: 'tr-data align-left',
            photo: '<img class="player-mug" onError="this.onerror=null;this.src=\'https://content.mlb.com/images/headshots/current/60x60/generic.png\';" src="https://content.mlb.com/images/headshots/current/60x60/{1}.png">',
            photoId: 'playerId',
        },
        {
            name: 'Round',
            field: 'round',
            headerClass: 'th-component-header align-center',
            fieldClass: 'tr-data align-center',
            displayFn: getRoundLabel,
        },
        {
            name: 'HR # <br/>(In round)',
            field: 'batterMatchupHrs',
            headerClass: 'th-component-header align-center',
            fieldClass: 'tr-data align-center',
            type: 'number',
        },
        {
            name: 'Exit Velocity<br/>(MPH)',
            field: 'exit_velocity_avg',
            headerClass: 'th-component-header align-center',
            fieldClass: 'tr-data align-center',
            type: 'number',
            // starting in 2024, HRs are reported to the whole number, whereas Savant has historically gone to the tenth
            displayFn: (val) => (val ? Math.round(val) : '--'),
            highlight: [105, 115],
            highlightColors: ['#ffffff', '#D82129'],
        },
        {
            name: 'Distance</br>(Feet)',
            field: 'bbdist',
            headerClass: 'th-component-header align-center',
            fieldClass: 'tr-data align-center',
            type: 'number',
            displayFn,
            highlight: [424.5, 475],
            highlightColors: ['#ffffff', '#D82129'],
        },
        {
            name: 'Launch Angle<br/>(Degrees)',
            field: 'launch_angle',
            headerClass: 'th-component-header align-center',
            fieldClass: 'tr-data align-center',
            type: 'number',
            displayFn,
        },
    ]

    // eslint-disable-next-line no-new
    new Table({
        id: 'hr_derby_table',
        headers,
        sortClass: 'column-sort',
        initialSortDirection: 'desc',
        defaultSort: [
            { field: 'round', state: 'desc' },
            { field: 'playerName', state: 'asc' },
            { field: 'batterMatchupHrs', state: 'desc' },
        ],
        data: (hits || []).map((d) => ({
            ...d,
            batterMatchupHrs: d.summary.batterMatchupHrs,
            // Property for guff
            exit_velocity_avg: d.result.computedMetrics.exitVelocity.value,
            bbdist: d.result.computedMetrics.projectedDistance.value,
            launch_angle: d.result.computedMetrics.launchAngle.value,
        })),
    })
}

export default UI
